module.exports = __webpack_public_path__ + "static/img/16.ba01252.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/16.png
// module id = NBuD
// module chunks = 0